import { Image } from '@/domains/core/Image/Image';
import { Block } from '@/domains/productDiscovery/ProductPage/b2c/components/Block/Block';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import { useBrand } from '@/domains/productDiscovery/ProductPage/modules/Brand/useBrand';

import styles from './productInformations.module.scss';

export const ProductInformations = () => {
  const { title, media } = useDetail();
  const { imageUrl } = useBrand();

  return (
    <Block className={styles.productInfoContainer}>
      <div className={styles.imageContainer}>
        <Image
          alt="product"
          src={media[0].thumbnailUrl}
          height="62"
          width="62"
          className={styles.productImage}
        />
        {imageUrl && (
          <Image
            alt="brand"
            src={imageUrl}
            height="24"
            width="62"
            className={styles.brandMobile}
            data-testid="brand-image-mobile"
          />
        )}
      </div>
      <div>
        {imageUrl && (
          <Image
            alt="brand"
            src={imageUrl}
            height="32"
            width="84"
            className={styles.brandDesktop}
            data-testid="brand-image-desktop"
          />
        )}
        <div className={styles.productTitle}>{title}</div>
      </div>
    </Block>
  );
};
